/* eslint-disable max-len */
import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import OrderRoutes from 'order/order-routes';
import EquipmentRoutes from 'equipment/equipment-routes';
import InstalledAt from 'installed-at/installed-at-routes';
import CustomerRoutes from 'customer/customer-routes';
import Home from 'home/containers/home-container';
import Worklists from 'worklist/containers/worklist-routes';
import Settings from 'settings/containers/settings-routes';
import PlanningBoard from 'planning-board/containers/planning-board-routes';
import TicketList from 'tickets/containers/ticket-list-routes';
import Technician from 'technician/containers/technician-container';
import SearchContainer from 'search/containers/search-container';
import TicketDetail from 'tickets/containers/detail/ticket-detail-routes';
import Title from 'common/title/Title';
import DirectRoutesHandler from 'direct/containers/direct-routes-handler-container';
import NavigationListener from '../containers/navigation-listener-container';
import NotificationRoutes from '../../../notification_call/notification-routes';
import CallRoutes from '../../../notification_call/call-routes';
import FunctionalLocationRoutes from '../../../functional-location/functional-location-routes';

export const ticketObjectRoutes = () => [
  '/tickets/object/:objectId?/filters/:filters/sort/:sort/view/:view',
  '/tickets/object/:objectId?/filters/:filters/sort/:sort',
  '/tickets/object/:objectId?/filters/:filters/view/:view',
  '/tickets/object/:objectId?/sort/:sort/view/:view',
  '/tickets/object/:objectId?/filters/:filters',
  '/tickets/object/:objectId?/sort/:sort',
  '/tickets/object/:objectId?/view/:view',
  '/tickets/object/:objectId?',
];

const MainRoutes = () => {
  const worklistRoutes = [
    '/worklists/:worklistId/filters/:filters/sort/:sort/view/:view',
    '/worklists/:worklistId/filters/:filters/sort/:sort',
    '/worklists/:worklistId/filters/:filters/view/:view',
    '/worklists/:worklistId/sort/:sort/view/:view',
    '/worklists/:worklistId/filters/:filters',
    '/worklists/:worklistId/sort/:sort',
    '/worklists/:worklistId/view/:view',
    '/worklists/:worklistId?',
  ];

  const ticketRoutes = [
    '/tickets/filters/:filters/sort/:sort/view/:view',
    '/tickets/filters/:filters/sort/:sort',
    '/tickets/filters/:filters/view/:view',
    '/tickets/sort/:sort/view/:view',
    '/tickets/filters/:filters',
    '/tickets/sort/:sort',
    '/tickets/view/:view',
    '/tickets',
  ];

  const planningBoardRoutes = [
    // 7 params
    '/planning-board/:worklistId/filters/:filters/sort/:sort/view/:view/ganttFilters/:ganttFilters/ganttSort/:ganttSort/ganttView/:ganttView',
    // 6 params
    '/planning-board/:worklistId/filters/:filters/sort/:sort/ganttFilters/:ganttFilters/ganttSort/:ganttSort/ganttView/:ganttView',
    '/planning-board/:worklistId/filters/:filters/view/:view/ganttFilters/:ganttFilters/ganttSort/:ganttSort/ganttView/:ganttView',
    '/planning-board/:worklistId/sort/:sort/view/:view/ganttFilters/:ganttFilters/ganttSort/:ganttSort/ganttView/:ganttView',
    '/planning-board/:worklistId/filters/:filters/sort/:sort/view/:view/ganttFilters/:ganttFilters/ganttView/:ganttView',
    '/planning-board/:worklistId/filters/:filters/sort/:sort/view/:view/ganttFilters/:ganttFilters/ganttSort/:ganttSort',
    '/planning-board/:worklistId/filters/:filters/sort/:sort/view/:view/ganttSort/:ganttSort/ganttView/:ganttView',
    // 5 params
    '/planning-board/:worklistId/sort/:sort/view/:view/ganttSort/:ganttSort/ganttView/:ganttView',
    '/planning-board/:worklistId/sort/:sort/view/:view/ganttFilters/:ganttFilters/ganttView/:ganttView',
    '/planning-board/:worklistId/sort/:sort/view/:view/ganttFilters/:ganttFilters/ganttSort/:ganttSort',
    '/planning-board/:worklistId/filters/:filters/view/:view/ganttSort/:ganttSort/ganttView/:ganttView',
    '/planning-board/:worklistId/filters/:filters/view/:view/ganttFilters/:ganttFilters/ganttView/:ganttView',
    '/planning-board/:worklistId/filters/:filters/view/:view/ganttFilters/:ganttFilters/ganttSort/:ganttSort',
    '/planning-board/:worklistId/filters/:filters/sort/:sort/ganttSort/:ganttSort/ganttView/:ganttView',
    '/planning-board/:worklistId/filters/:filters/sort/:sort/ganttFilters/:ganttFilters/ganttView/:ganttView',
    '/planning-board/:worklistId/filters/:filters/sort/:sort/ganttFilters/:ganttFilters/ganttSort/:ganttSort',
    '/planning-board/:worklistId/filters/:filters/ganttFilters/:ganttFilters/ganttSort/:ganttSort/ganttView/:ganttView',
    '/planning-board/:worklistId/sort/:sort/ganttFilters/:ganttFilters/ganttSort/:ganttSort/ganttView/:ganttView',
    '/planning-board/:worklistId/view/:view/ganttFilters/:ganttFilters/ganttSort/:ganttSort/ganttView/:ganttView',
    '/planning-board/:worklistId/filters/:filters/sort/:sort/view/:view/ganttView/:ganttView',
    '/planning-board/:worklistId/filters/:filters/sort/:sort/view/:view/ganttSort/:ganttSort',
    '/planning-board/:worklistId/filters/:filters/sort/:sort/view/:view/ganttFilters/:ganttFilters',
    // 4 params
    '/planning-board/:worklistId/ganttFilters/:ganttFilters/ganttSort/:ganttSort/ganttView/:ganttView',
    '/planning-board/:worklistId/view/:view/ganttSort/:ganttSort/ganttView/:ganttView',
    '/planning-board/:worklistId/view/:view/ganttFilters/:ganttFilters/ganttSort/:ganttSort',
    '/planning-board/:worklistId/view/:view/ganttFilters/:ganttFilters/ganttView/:ganttView',
    '/planning-board/:worklistId/sort/:sort/ganttSort/:ganttSort/ganttView/:ganttView',
    '/planning-board/:worklistId/sort/:sort/ganttFilters/:ganttFilters/ganttSort/:ganttSort',
    '/planning-board/:worklistId/sort/:sort/ganttFilters/:ganttFilters/ganttView/:ganttView',
    '/planning-board/:worklistId/filters/:filters/ganttSort/:ganttSort/ganttView/:ganttView',
    '/planning-board/:worklistId/filters/:filters/ganttFilters/:ganttFilters/ganttSort/:ganttSort',
    '/planning-board/:worklistId/filters/:filters/ganttFilters/:ganttFilters/ganttView/:ganttView',
    '/planning-board/:worklistId/filters/:filters/sort/:sort/ganttView/:ganttView',
    '/planning-board/:worklistId/filters/:filters/view/:view/ganttView/:ganttView',
    '/planning-board/:worklistId/sort/:sort/view/:view/ganttView/:ganttView',
    '/planning-board/:worklistId/filters/:filters/sort/:sort/ganttSort/:ganttSort',
    '/planning-board/:worklistId/filters/:filters/view/:view/ganttSort/:ganttSort',
    '/planning-board/:worklistId/sort/:sort/view/:view/ganttSort/:ganttSort',
    '/planning-board/:worklistId/filters/:filters/sort/:sort/ganttFilters/:ganttFilters',
    '/planning-board/:worklistId/filters/:filters/view/:view/ganttFilters/:ganttFilters',
    '/planning-board/:worklistId/sort/:sort/view/:view/ganttFilters/:ganttFilters',
    '/planning-board/:worklistId/filters/:filters/sort/:sort/view/:view',
    // 3 params
    '/planning-board/:worklistId/ganttSort/:ganttSort/ganttView/:ganttView',
    '/planning-board/:worklistId/ganttFilters/:ganttFilters/ganttView/:ganttView',
    '/planning-board/:worklistId/ganttFilters/:ganttFilters/ganttSort/:ganttSort/',
    '/planning-board/:worklistId/filters/:filters/ganttView/:ganttView',
    '/planning-board/:worklistId/view/:view/ganttView/:ganttView',
    '/planning-board/:worklistId/sort/:sort/ganttView/:ganttView',
    '/planning-board/:worklistId/filters/:filters/ganttSort/:ganttSort',
    '/planning-board/:worklistId/view/:view/ganttSort/:ganttSort',
    '/planning-board/:worklistId/sort/:sort/ganttSort/:ganttSort',
    '/planning-board/:worklistId/filters/:filters/ganttFilters/:ganttFilters',
    '/planning-board/:worklistId/view/:view/ganttFilters/:ganttFilters',
    '/planning-board/:worklistId/sort/:sort/ganttFilters/:ganttFilters',
    '/planning-board/:worklistId/filters/:filters/sort/:sort',
    '/planning-board/:worklistId/filters/:filters/view/:view',
    '/planning-board/:worklistId/sort/:sort/view/:view',
    // 2 param
    '/planning-board/:worklistId/ganttView/:ganttView',
    '/planning-board/:worklistId/ganttSort/:ganttSort',
    '/planning-board/:worklistId/ganttFilters/:ganttFilters',
    '/planning-board/:worklistId/filters/:filters',
    '/planning-board/:worklistId/sort/:sort',
    '/planning-board/:worklistId/view/:view',
    // 1 param
    '/planning-board/:worklistId?',
    // 0 params
    '/planning-board',
  ];

  return (
    <Title>
      <NavigationListener />
      <Routes>
        <Route path='/home' element={<Home />} />
        <Route path='/search/*' element={<SearchContainer />} />
        <Route path='/settings/*' element={<Settings />} />
        {worklistRoutes?.map((r, i) => <Route path={`${r}/*`} key={i} element={<Worklists />} />)}
        <Route path='/tickets/object/:objectId?/*' element={<TicketList />} />
        <Route path='/ticket/new/:objectId/type/:type/*' element={<TicketDetail />} />
        <Route
          path='/ticket/:ticketId/:ticketFullId/*'
          element={<TicketDetail />}
        />
        {ticketRoutes?.map((r, i) => <Route path={`${r}/*`} key={i} element={<TicketList />} />)}
        <Route path='/customer/:customerId/*' element={<CustomerRoutes />} />
        <Route path='/installedat/:installedAtId/*' element={<InstalledAt />} />
        <Route path='/functionallocation/:functionalLocationId/*' element={<FunctionalLocationRoutes />} />
        <Route path='/equipment/:equipmentId/*' element={<EquipmentRoutes />} />
        <Route path='/technician/:technicianId/*' element={<Technician />} />
        <Route path='/order/:orderIds/position/:currentposition/*' element={<OrderRoutes />} />
        <Route path='/order/:orderIds/*' element={<OrderRoutes />} />
        <Route path='/direct/:type/*' element={<DirectRoutesHandler />} />
        <Route path='/notification/:notificationId/*' element={<NotificationRoutes />} />
        <Route path='/call/:callId/*' element={<CallRoutes />} />
        {planningBoardRoutes?.map((r, i) => <Route path={`${r}/*`} key={i} element={<PlanningBoard />} />)}
        <Route
          path='/'
          element={<Navigate to='/home' replace />}
        />
        <Route
          path='*'
          element={<Navigate to='/home' replace />}
        />
      </Routes>
    </Title>
  );
};
export default MainRoutes;
